import Err from '../../models/err';

export default function createTakenActiveCallError() {
  return new Err({ code: Err.Code.TAKEN, attr: 'agentId', detail: 'agent already has an active call' });
}



// WEBPACK FOOTER //
// ./src/scripts/domain/factories/error/create_taken_active_call_error.js